import Vue from 'vue'
import mutations from './mutations'
import clientsInvoices from '@/api/clientsInvoices'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems ({ commit }, { childCompanyId, electronicDeviceId, number, dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        clientsInvoices.getAll({ childCompanyId, electronicDeviceId, number, dateFrom, dateTo })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    getCommunicationData ({ commit }, { childCompanyId, invoiceId }) {
      return new Promise((resolve, reject) => {
        clientsInvoices.getCommunicationData({ childCompanyId, id: invoiceId })
          .then(response => {
            const items = response.data.items
            commit('addFursCommunicationToItem', { invoiceId, fursCommunication: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations,
    addFursCommunicationToItem (store, { invoiceId, fursCommunication }) {
      const invoice = store.items[invoiceId]
      if (!invoice.furs) {
        Vue.set(store.items[invoiceId], 'furs', {})
      }
      fursCommunication.forEach(element => {
        const requestBody = JSON.parse(element.request_body)
        const requestId = requestBody.InvoiceRequest.Header.MessageID
        const communication = {
          requestId,
          requestBody,
          requestDate: element.request_date,
          responseBody: JSON.parse(element.response_body),
          responseDate: element.response_date
        }
        Vue.set(store.items[invoiceId].furs, requestId, communication)
      })
    }
  }
}
